import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import CharsLimitedTextField from "components/CharsLimitedTextField";
import DateSelect from "components/DateSelect";
import { DateTime } from "luxon";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Question from "../FormScript/components/Question";
import useScriptManagementStore from "../hooks/useScriptManagementStore";

const MAX_DESCRIPTION = 255;

export default function MobilePublishedDisplay() {
  const { script, handleUpdateScript, setHasScriptError } =
    useScriptManagementStore();
  const { type, title, languageCode, questions } = script;

  function updateStartDate(startDate: string) {
    handleUpdateScript("startDate", startDate);
  }

  function updateEndDate(startDate: string) {
    handleUpdateScript("endDate", startDate);
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h5" gutterBottom>
          <em>{type}</em>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom>
          {`Language: ${languageCode}`}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CharsLimitedTextField
          maxChars={MAX_DESCRIPTION}
          label={"Description *"}
          onChange={(event) => {
            handleUpdateScript("description", event.target.value);
            if (event.target.value.length > MAX_DESCRIPTION) {
              setHasScriptError(true);
            } else {
              setHasScriptError(false);
            }
          }}
          multiline={true}
          rows={3}
          value={script.description}
        />
      </Grid>
      <Grid item xs={6}>
        <DateSelect
          defaultDate={DateTime.fromISO(script.startDate)}
          label="Start Date"
          customError="Invalid Start Date"
          minDate={DateTime.fromISO(script.startDate) || DateTime.now()}
          onChange={updateStartDate}
          onError={setHasScriptError}
        />
      </Grid>
      <Grid item xs={6}>
        <DateSelect
          defaultDate={DateTime.fromISO(script.endDate)}
          label="End Date"
          customError="Invalid End Date"
          minDate={
            script.startDate
              ? DateTime.fromISO(script.startDate).plus({ days: 1 })
              : DateTime.now().plus({ days: 1 })
          }
          onChange={updateEndDate}
          onError={setHasScriptError}
        />
      </Grid>
      <Grid item xs={12} sx={{ width: "100%" }}>
        <DndProvider backend={HTML5Backend}>
          {questions.map((question, index) => (
            <Box key={`question-${question.id}`}>
              <Question
                question={question}
                index={index}
                isDraggable={false}
                isEditable={false}
              />
            </Box>
          ))}
        </DndProvider>
      </Grid>
    </Grid>
  );
}
